import { purry } from './purry';
export function merge() {
  return purry(_merge, arguments);
}

function _merge(a, b) {
  // tslint:disable-next-line:prefer-object-spread
  return Object.assign({}, a, b);
}